<script setup>
defineEmits(['add'])
</script>
<template>
  <tr @keydown.enter.prevent.capture.stop="confirmEdit">
    <td class="pt-2">
      <v-select
        ref="poste-input"
        v-model="tempOperation.posteAIM"
        :items="postesNonDefinits"
        :item-value="'posteAIMId'"
        :item-text="'libelle'"
        label="Poste"
        filled
        color="secondary"
        item-color="secondary"
        dense
      >
      </v-select>
    </td>
    <td class="pt-2">
      <v-text-field
        filled
        color="secondary"
        hide-spin-buttons
        dense
        ref="montant-input"
        v-model="tempOperation.montant"
        type="number"
        label="Montant"
        :rules="[(v) => !!v || 'Vous devez renseigner un montant']"
      ></v-text-field>
    </td>
    <td>
      <v-tooltip left>
        Ajouter le poste
        <template #activator="{ on, attrs }">
          <v-btn class="mx-1" v-on="on" v-bind="attrs" color="success" @click.prevent.stop="confirmEdit"
            ><v-icon>mdi-plus</v-icon>Ajouter
          </v-btn>
        </template>
      </v-tooltip>
    </td>
  </tr>
</template>

<script>
export default {
  name: 'ajouter-operation-ajustement-form',
  data() {
    return {
      tempOperation: {},
    }
  },
  props: {
    postesNonDefinits: {
      type: Array,
      requires: true,
    },
  },
  computed: {
    isValid() {
      return this.isValidPoste && this.isValidMontant
    },
    isValidMontant() {
      return !isNaN(parseFloat(this.tempOperation.montant)) && this.tempOperation.montant.length > 0
    },
    isValidPoste() {
      return this.postesNonDefinits.some((poste) => poste.posteAIMId === this.tempOperation.posteAIM)
    },
    posteSelectionne() {
      return this.postesNonDefinits.filter((value) => value.posteAIMId === this.tempOperation.posteAIM).at(0)
    },
  },
  methods: {
    confirmEdit() {
      if (this.isValidMontant && this.isValidPoste) {
        this.$emit('add', {
          posteAIM: this.posteSelectionne,
          montant: parseFloat(this.tempOperation.montant),
        })
        this.teardownEdit()
      }
    },
    teardownEdit() {
      this.tempOperation = {}
    },
  },
}
</script>
<style scoped>
.modele-table-aim-actions {
  max-width: 6vh !important;
}

tr:hover {
  background-color: transparent !important;
}
</style>
